module.exports = __webpack_public_path__ + "img/p1.6704dc2e.png";